module.exports = __webpack_public_path__ + "static/media/bubble-right.8aa498a3.png";